import { render, staticRenderFns } from "./issueCreateCounts.vue?vue&type=template&id=115bc2c8&scoped=true&lang=pug&"
import script from "./issueCreateCounts.vue?vue&type=script&setup=true&lang=js&"
export * from "./issueCreateCounts.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./issueCreateCounts.vue?vue&type=style&index=0&id=115bc2c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115bc2c8",
  null
  
)

export default component.exports